export interface Terms {
  footer: string;
  marketing: string;
  marketingHeader: string;
  prefCenterFooter: string;
  tracking: string;
  trackingHeader: string;
}

export class RubiqConsentText {
  success: boolean;
  terms: Terms;

  constructor(success: boolean, terms: Terms) {
    this.success = success;
    this.terms = terms;
  }
}
